// extracted by mini-css-extract-plugin
module.exports = {"header":"admin-portal__PageHeader__header"};